import * as React from 'react'
import { createIcon } from './createIcon'
import { IconOptions } from './icon-options'

function IconContent({ color }: IconOptions) {
  return (
    <React.Fragment>
      <circle cx='12' cy='12' r='2' fill={color} />
      <circle cx='12' cy='12' r='7.5' stroke={color} />
    </React.Fragment>
  )
}

export const RadiusIcon = createIcon(IconContent)
